import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "panel-message-danger min-h-0" }
const _hoisted_2 = { class: "mr-s1" }
const _hoisted_3 = { class: "mr-s1" }
const _hoisted_4 = { key: 0 }

import { useI18n } from 'vue-i18n';
import { useStore } from 'vuex';
import { getChainNameById } from '@/helpers/networkParams.helper';
import { ChainId } from '@/sdk/constants';
import { computed } from 'vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'PortfolioReserveExceededMessage',
  props: {
    tokenSymbol: null,
    chainId: null,
    amount: null
  },
  emits: ["click"],
  setup(__props: any, { emit: emits }: { emit: ({
  (e: 'click'): void;
}), expose: any, slots: any, attrs: any }) {

const props = __props as {
  tokenSymbol: string;
  chainId: ChainId;
  amount: string;
}



const { state } = useStore();
const { t } = useI18n();

const networkName = computed(() => getChainNameById(props.chainId));

return (_ctx: any,_cache: any) => {
  const _component_Button = _resolveComponent("Button")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("span", _hoisted_2, _toDisplayString(_unref(t)('singleSide.infoMessage.portfolioReserveExceeded[0]', {
        token: __props.tokenSymbol,
        network: _unref(networkName),
      })), 1),
    _createElementVNode("span", _hoisted_3, _toDisplayString(_unref(t)('singleSide.infoMessage.portfolioReserveExceeded[1]')), 1),
    _createVNode(_component_Button, {
      class: "button-plain mr-s1 underline",
      onClick: _cache[0] || (_cache[0] = ($event: any) => (emits('click'))),
      label: `${__props.amount} ${__props.tokenSymbol}`
    }, null, 8, ["label"]),
    (_unref(state).layout.isDesktop)
      ? (_openBlock(), _createElementBlock("br", _hoisted_4))
      : _createCommentVNode("", true),
    _createElementVNode("span", null, _toDisplayString(_unref(t)('singleSide.infoMessage.portfolioReserveExceeded[2]')), 1)
  ]))
}
}

})